module.exports = __webpack_public_path__ + "assets/img/destroy_mining_active.7ce407c1.png";